const LOGO_BASE = "https://members-legacy.worldservicesgroup.com/files/pic/";

export function firmProfilePath(companyType: string, slug: string, firmId: number): string {
  let kind = "law-firm";
  if (companyType === "Financial Management" || companyType === "Investment Banking") {
    kind = "investment-bank";
  } else if (companyType === "Accounting") {
    kind = "accounting-firm";
  }
  return `/member/${kind}/${(slug || "firm").toLowerCase()}/${firmId}`;
}

export function logoUrl(logoName: string): string {
  return `${LOGO_BASE}${logoName}`;
}
